interface MissingChipsProps {
  saknarU: boolean
  saknarSpec: boolean
  invanarSvar: boolean
}

export default function MissingChips({ saknarU, saknarSpec, invanarSvar }: MissingChipsProps) {
  if (!saknarU && !saknarSpec && !invanarSvar) return null
  return (
    <span className="missing-chips">
      {saknarU && (
        <span className="missing-chip warn">
          <WarnIcon />
          Saknar underrättelse
        </span>
      )}
      {saknarSpec && (
        <span className="missing-chip warn">
          <WarnIcon />
          Saknar spec
        </span>
      )}
      {invanarSvar && (
        <span className="missing-chip info">
          Inväntar svar
        </span>
      )}
    </span>
  )
}

function WarnIcon() {
  return (
    <svg width="10" height="10" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M8 2L14 13H2L8 2z" />
      <path d="M8 7v3M8 11.5v.5" strokeLinecap="round" />
    </svg>
  )
}
